import { ref } from 'vue';

export function useVideoWidth() {
  const wistiaMaxWidth = ref('400px'); // default value or null

  function setMaxWidth(width: string) {
    wistiaMaxWidth.value = width;
  }

  return {
    wistiaMaxWidth,
    setMaxWidth,
  };
}
